<template>
    <div>
        <el-form :model="metadata" :rules="rules" v-if="mode==='edit' || mode ==='add'" ref="form" label-width="150px" :label-position="'left'">
          <div v-for="section in page_structure['fields']" class="detail-section" :key="section['name']">
            <h1>{{section['name']}}</h1>
            <el-form-item
              v-for="(field, idx) in section['fields'] || [section]"
              :key="idx"
              :label="field['display']['name']"
              :prop="field['change']['name']? field['change']['name']: field['source']['key']"
            >
              <div v-if="check_field_available(mode, field) === false && field['display']['type'] === 'string'">
                <el-input :disabled="true" v-model="metadata[field['source']['key']]" :placeholder="field['change']['placeholder'] || ''" @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)"></el-input>
              </div>
              <div v-else-if="check_field_available(mode, field) === false && field['display']['type'] === 'multi-line-string'">
                <el-input :disabled="true" type="textarea" :autosize="{ minRows: 5}" v-model="metadata[field['source']['key']]" ></el-input>
              </div>
              <div v-else-if="check_field_available(mode, field) === false && ['multi-string','multiple-select-as-is'].indexOf(field['display']['type']) !== -1">
                <el-tag
                    v-for="(tag, idx) in metadata[field['source']['key']]"
                    :key="idx"
                    type='info'
                >
                    {{tag}}
                </el-tag>
              </div>
              <div v-else-if="check_field_available(mode, field) === false && field['display']['type'] === 'image'">
                <a :href="APP+'/'+metadata[field['source']['key']]" target="_blank"><img class="digital-object-img" v-if="metadata[field['source']['key']]" :src="APP+'/'+metadata[field['source']['key']]"></a>
              </div>
              <div v-else-if="check_field_available(mode, field) === false">
                <h1>Unknown field type&nbsp;'{{field['display']['type']}}'</h1>
              </div>
              <div v-else-if="field['change']['type'] === 'string'">
                <el-input v-model="metadata[field['source']['key']]" @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)"></el-input>
                <span v-if="field['change']['description']" class="input-string-description">{{field['change']['description']}}</span>
              </div>
              <div v-else-if="field['change']['type'] === 'multi-string'">
                <InputTag
                    v-if="(mode ==='edit' && typeof metadata[field['source']['key']] !== 'undefined' && metadata[field['source']['key']] !== null) || mode === 'add'"
                    v-model="metadata[field['source']['key']]"
                    @update:tags="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)"
                    :add-tag-on-blur="true"
                ></InputTag>
                <span class="aux-info-text">輸入關鍵字後直接按enter，即可新增</span>
              </div>
              <div v-else-if="field['change']['type'] === 'multi-line-string'">
                <el-input v-model="metadata[field['source']['key']]" type="textarea" :autosize="{ minRows: 5}" @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)"></el-input>
              </div>
              <div v-else-if="field['change']['type'] === 'datetime'">
                <el-date-picker
                  v-model="metadata[field['source']['key']]"
                  type="date"
                  placeholder="選擇日期"
                  value-format="yyyy-MM-dd"
                  @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)">
                </el-date-picker>
              </div>
              <div v-else-if="field['change']['type'] === 'single-select-as-is' && field['change']['options']['additional']">
                  <SelectWithOptionOthers 
                    v-model="metadata[field['source']['key']]" 
                    :options="field['change']['options']['list']"
                    @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)"
                  >
                  </SelectWithOptionOthers>
              </div>
              <div v-else-if="field['change']['type'] === 'single-select-as-is' || (field['change']['type'] === 'single-select' && field['change']['options']['type'] === 'fixed')">
                <el-radio-group v-model="metadata[field['source']['key']]" @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)">
                  <el-radio 
                    v-for="(item, idx) in field['change']['options']['list']"
                    :key="idx"
                    :label="item.value"
                  > {{item.label}}
                  </el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="field['change']['type'] === 'multiple-select-as-is' && field['change']['options']['additional']">
                <MultipleSelectWithOptionOther 
                    v-model="metadata[field['source']['key']]" 
                    :options="field['change']['options']['list']"
                    @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)"
                />
              </div>
              <div v-else-if="field['change']['type'] === 'multiple-select-as-is'">
                <el-radio-group v-model="metadata[field['source']['key']]" @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)">
                    <el-checkbox-group v-model="metadata[field['source']['key']]" @change="(val) => inner_handle_dynamic_form_update(field['source']['key'], val)">
                        <el-checkbox 
                            v-for="(item, idx) in field['change']['options']['list']"
                            :key="idx"
                            :label="item.value"
                        > {{item.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-radio-group>
              </div>
              <div v-else-if="field['change']['type'] === 'password'">
                <el-input v-model="metadata[field['change']['name']]" 
                    @change="(val) => inner_handle_dynamic_form_update(field['change']['name'], val)" 
                    type='password'
                    :placeholder="field['change']['placeholder']">
                </el-input>
              </div>
              <div v-else-if="field['change']['type'] === 'single-select' && ['db','vuex'].indexOf(field['change']['options']['type']) !== -1">
                <!-- <el-select v-model="metadata[field['change']['name']]" placeholder="請選擇"> -->
                <el-select v-model="metadata[field['change']['name']]" placeholder="請選擇" @change="(val) => inner_handle_dynamic_form_update(field['change']['name'], val)">
                  <el-option
                    v-for="(item, idx) in options[field['change']['name']]"
                    :key="idx"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div v-else-if="field['change']['type'] === 'single-file'">
                <el-upload
                  v-if="show_components"
                  class="upload-file"
                  action=""
                  :http-request="(file) => handle_file_upload(field['change']['name'], file)" 
                >
                  <el-button slot="trigger" size="small" type="primary">選取文件</el-button>
                </el-upload>
              </div>
              <div v-else-if="field['change']['type'] === 'multiple-file'">
                <el-upload
                  v-if="show_components"
                  class="upload-file"
                  action=""
                  multiple
                  :http-request="(file) => handle_file_upload(field['change']['name'], file)"
                  :on-remove="(file) => inner_handle_file_remove(field['change']['name'], file)"
                >
                  <el-button slot="trigger" size="small" type="primary">選取文件</el-button>
                </el-upload>
              </div>
              <div v-else-if="field['change']['type'] === 'forestry-data'">
                <ForestryMultiValueForm
                  :name="field['change']['name']"
                  :mode="mode"
                  :handle_dynamic_form_update="handle_dynamic_form_update"
                  :preloaded_data="metadata[field['change']['name']]"
                  :preloaded_data_update_flag="preloaded_data_update_flag"
                  @update-valid="(valid)=>{notify_valid(valid)}"
                >
                </ForestryMultiValueForm>
              </div>
              <div v-else-if="field['change']['type'] === 'radio-with-datepicker' && field['change']['options']['additional']">
                <RadioWithDatePicker
                  v-model="metadata[field['source'][0]['key']]"
                  :options="field['change']['options']['list']"
                  :start_date="metadata[field['source'][1]['key']]"
                  :end_date="metadata[field['source'][2]['key']]"
                  :handle_dynamic_form_update="handle_dynamic_form_update"
                >
                </RadioWithDatePicker>
              </div>
              <div v-else-if="field['change']['type'] === 'upload-file-with-list-table'">
                <UploadImageFile
                  :upload_cloumn_show="field['change']['options']['upload_column_show']"
                  :already_image_list="metadata[field['source']['key']]"
                  :check_file_type_before_upload="check_file_type_before_upload"
                  :handle_file_upload="handle_file_upload"
                  :file_list_name="field['change']['name']"
                  :handle_file_remove="inner_handle_file_remove"
                  :handle_list_delete="handle_list_delete"
                  :handle_dynamic_form_update="handle_dynamic_form_update"
                  :preloaded_data_update_flag="preloaded_data_update_flag"
                  :accept_file_type="field['change']['options']['accept_file_type']"
                >
                </UploadImageFile>
              </div>
            </el-form-item>
          </div>
        </el-form>

        <div v-else-if="mode==='view'">
            <div v-for="section in page_structure['fields']" class="detail-section" :key="section['name']">
                <h4 class="detail-section-title">{{section['name'] || ''}}</h4>
                <table class="normal-table">
                    <tr
                        v-for="(field, idx) in section['fields'] || [section]"
                        :key="idx"
                    >
                        <template v-if="field['display']['type'] === 'password'">
                            <td class="field">{{field['display']['name']}}</td>
                            <td>********</td>
                        </template>
                        <template v-else-if="field['display']['type'] === 'image'">
                            <td class="field">{{field['display']['name']}}</td>
                            <td><a :href="APP+'/'+metadata[field['source']['key']]" target="_blank">
                                <img class="digital-object-img" v-if="metadata[field['source']['key']]" :src="APP+'/'+metadata[field['source']['key']]">
                            </a></td>
                        </template>
                        <template v-else-if="['multi-string','multiple-select-as-is'].indexOf(field['display']['type']) !== -1">
                            <template v-if="no_show_empty && no_show_empty === true">
                                <template v-if="metadata[field['source']['key']] != '' && metadata[field['source']['key']] != null">   
                                    <td class="field">{{field['display']['name']}}</td>
                                    <td><el-tag
                                        v-for="(tag, idx) in metadata[field['source']['key']]"
                                        :key="idx"
                                        type='info'
                                    >
                                        {{tag}}
                                    </el-tag></td>
                                </template>
                            </template>
                            <template v-else>
                                <td class="field">{{field['display']['name']}}</td>
                                <td><el-tag
                                    v-for="(tag, idx) in metadata[field['source']['key']]"
                                    :key="idx"
                                    type='info'
                                >
                                    {{tag}}
                                </el-tag></td>
                            </template> 
                            
                        </template>
                        <template v-else-if="field['display']['type'] === 'forestry-data'">
                            <template v-if="no_show_empty && no_show_empty === true">
                                <template v-if="metadata[field['source']['key']].length !== 0">   
                                    <td class="field">{{field['display']['name']}}</td>
                                    <td>
                                        <ForestryMultiValueForm
                                            :name="field['source']['key']"
                                            :mode="mode"
                                            :handle_dynamic_form_update="handle_dynamic_form_update"
                                            :preloaded_data="metadata[field['source']['key']]"
                                            :preloaded_data_update_flag="preloaded_data_update_flag"
                                        >
                                        </ForestryMultiValueForm>
                                    </td>
                                </template> 
                            </template>
                            <template v-else>
                                <td class="field">{{field['display']['name']}}</td>
                                <td>
                                    <ForestryMultiValueForm
                                        :name="field['source']['key']"
                                        :mode="mode"
                                        :handle_dynamic_form_update="handle_dynamic_form_update"
                                        :preloaded_data="metadata[field['source']['key']]"
                                        :preloaded_data_update_flag="preloaded_data_update_flag"
                                    >
                                    </ForestryMultiValueForm>
                                </td>
                            </template>

                            
                        </template>
                        <template v-else>
                            <template v-if="no_show_empty && no_show_empty === true">
                                <template v-if="metadata[field['source']['key']] != '' && metadata[field['source']['key']] != null">   
                                    <td class="field">{{field['display']['name']}}</td>
                                    <td>{{metadata[field['source']['key']]}}</td>
                                </template> 
                            </template>
                            <template v-else>
                                <td class="field">{{field['display']['name']}}</td>
                                <td>{{metadata[field['source']['key']]}}</td>
                            </template>
                            
                        </template>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import InputTag from 'vue-input-tag'
import ForestryMultiValueForm from '@/components/backstage/MultiValueForm/ForestryMultiValueForm.vue'
import SelectWithOptionOthers from '@/components/backstage/SelectWithOptionOthers/SelectWithOptionOthers.vue'
import MultipleSelectWithOptionOther from '@/components/backstage/MultipleSelectWithOptionOthers/MultipleSelectWithOptionOthers.vue'
import RadioWithDatePicker from '@/components/backstage/RadioWithDatePicker/RadioWithDatePicker.vue'
import UploadImageFile from '@/components/backstage/UploadImageForm/UploadImageFile.vue'

  export default {
    components: {
        InputTag,
        ForestryMultiValueForm,
        SelectWithOptionOthers,
        MultipleSelectWithOptionOther,
        RadioWithDatePicker,
        UploadImageFile
    },
    props: [
        'mode','handle_dynamic_form_update','handle_file_upload',
        'handle_file_remove','page_structure','preloaded_data',
        'preloaded_data_update_flag','preloaded_rules', 
        'handle_list_delete','init_flag', 'check_file_type_before_upload','exported', 
        'no_show_empty','test'],
    data() {
      return {
          metadata: {},
          options: {},
          options_data: {},
          rules: typeof this.preloaded_rules !== 'undefined'? this.preloaded_rules: {},
          show_components: true
      }
    },
    computed: {
        APP () {
            return process.env.VUE_APP_URL
        }
    },
    watch: {
        preloaded_data_update_flag: function () {
            this.update_form(this.preloaded_data)
        },
        preloaded_data: function (data) {
            this.update_form(data)
        },
        init_flag: function () {
            this.init()
        }
    },
    created: function () {
        this.init()
    },
    mounted(){
        console.log(this.page_structure)
        console.log(this.preloaded_data)
        console.log(this.no_show_empty)
        console.log(this.test)
        
    },
    methods: {
        init () {
            console.log('EditViewForm::created(): preloaded_data:', this.preloaded_data)
            this.show_components = false
            console.log('EditViewForm::created(): component visible= false')
            this.$nextTick(function () {
                this.show_components = true
                console.log('EditViewForm::created(): component visible= true')
            })
            this.update_form(this.preloaded_data)

            if (typeof this.exported !== 'undefined') {
                this.$nextTick(function() {
                    this.exported['form_ref'] = this.$refs['form']
                })
            }
        },
        check_field_available(mode, field) {
            if (mode === 'view') {
                return true
            }
            else if (mode === 'edit') {
                return field['change']['editable']
            }
            else if (mode === 'add') {
                return field['change']['addable']
            }
            else {
                console.log('err: EditViewForm: invalid mode: ', mode)
                return false
            }
        },
        validate_form (){
            if (this.$refs['form']) {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit('update-valid', true)
                    } else {
                        this.$emit('update-valid', false)
                        console.log('EditViewForm: validation failed')
                    }
                })
            }
        },
        inner_handle_dynamic_form_update (key, val) {
            this.metadata[key] = JSON.parse(JSON.stringify(val))

            this.update_dependant (key, val)

            if (this.handle_dynamic_form_update) {
                this.handle_dynamic_form_update(key, JSON.parse(JSON.stringify(val)))
            }

            this.validate_form()
        },
        dependant_need_to_be_updated(updated_field, field) {
            if (!field['depend']) {
                return false
            }

            if ( (field['depend']['on'] === updated_field['source']['key'] || 
                  field['depend']['on'] === updated_field['change']['name'] )
            ) {
                if ( field['depend']['type'] === 'domestic' ) {
                    if (field['depend']['level'] === 0) {
                        return true
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level')
                        return false
                    }
                }
                else if ( field['depend']['type'] === 'foreign' ) {
                    if (field['depend']['level'] === 1) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    console.log('err: EditViewForm: incorrect depend type')
                    return false
                }
            } else if ( updated_field['depend'] && field['depend']['on'] === updated_field['depend']['on']) {
                if ( field['depend']['type'] === 'domestic' ) {
                    if (field['depend']['level'] === updated_field['depend']['level']) {
                        return true
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level')
                        return false
                    }
                }
                else if ( field['depend']['type'] === 'foreign' ) {
                    if (field['depend']['level'] === updated_field['depend']['level'] + 1) {
                        return true
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level')
                        return false
                    }
                }
                else {
                    console.log('err: EditViewForm: incorrect depend type')
                    return false
                }
            } 
            else {
                return false
            }
        },
        dependant_need_to_be_cleared(updated_field, field) {
            if (!field['depend']) {
                return false
            }

            // if (updated_field.source.key === 'recordgroup_name' && field.source.key === 'series_name')
            // {
            //     debugger
            // }

            if ( (field['depend']['on'] === updated_field['source']['key'] || 
                  field['depend']['on'] === updated_field['change']['name'] )
            ) {
                if ( field['depend']['type'] === 'domestic' ) {
                    if (field['depend']['level'] === 0) {
                        return false
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level on clear')
                        return false
                    }
                }
                else if ( field['depend']['type'] === 'foreign' ) {
                    if (field['depend']['level'] >= 1) {
                        return true
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level on clear')
                        return false
                    }
                }
                else {
                    console.log('err: EditViewForm: incorrect depend type on clear')
                    return false
                }
            } else if ( updated_field['depend'] && field['depend']['on'] === updated_field['depend']['on']) {
                if ( field['depend']['type'] === 'domestic' ) {
                    if (field['depend']['level'] === updated_field['depend']['level']) {
                        return true
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level on clear')
                        return false
                    }
                }
                else if ( field['depend']['type'] === 'foreign' ) {
                    if (field['depend']['level'] >= updated_field['depend']['level'] + 1) {
                        return true
                    }
                    else {
                        console.log('err: EditViewForm: incorrect depend level on clear')
                        return false
                    }
                }
                else {
                    console.log('err: EditViewForm: incorrect depend type on clear')
                    return false
                }
            } 
            else {
                return false
            }
        },
        update_dependant (key, val) {
            let updated_field = null
            for (let section of this.page_structure['fields']) {
                for (let field of section['fields'] || [section]) {
                   if (field['source']['key'] === key || field['change']['name'] === key) {
                       updated_field = field
                       break
                   }
                }
            }

            for (let section of this.page_structure['fields']) {
                for (let field of section['fields'] || [section]) {
                    if (!field['depend'] || !field['depend']['on']) {
                        continue
                    }

                    if ( this.dependant_need_to_be_updated(updated_field, field) ) {                    
                        if (field['depend']['type'] === 'foreign') {
                            if (updated_field['change']['type'] === 'single-select') {
                                if (field['change']['options']['type'] === 'db') {
                                    this.get_options(field['change']['name'])
                                } else if (updated_field['change']['options']['type'] === 'fixed') {
                                    console.log('err: EditViewForm: selection need to be update but actually selection is fixed ')
                                } else {
                                    console.log('err: EditViewForm: unknown depended change options type:', updated_field['change']['option']['type'])
                                }
                            }
                            else if (updated_field['change']['type'] === 'single-select-as-is') {
                                if (updated_field['change']['options']['type'] === 'fixed') {
                                    this.get_options(field['change']['name'])
                                } else {
                                    console.log('err: EditViewForm: unknown depended change options type:', updated_field['change']['option']['type'])
                                }
                            }
                            else {
                                console.log('err: EditViewForm: unknown depended change type:', updated_field['change']['type'])
                            }
                        }
                        else if (field['depend']['type'] === 'domestic') {
                            if (updated_field['change']['type'] === 'single-select') {
                                if (!field['change']['options']) {
                                    let selected = null
                                    for (let option_data of this.options_data[updated_field['change']['name']]) {
                                        if (option_data[updated_field['change']['options']['value']] === this.metadata[updated_field['change']['name']]) {
                                            selected = option_data
                                            break 
                                        }
                                    }
                                    this.metadata[field['change']['name'] || field['source']['key']] = selected[field['change']['name'] || field['source']['key']]
                                }
                                else if (field['change']['options']['type'] === 'db') {
                                    console.log('err: EditViewForm: same level selection cannot be domestic depended ')
                                } else if (updated_field['change']['options']['type'] === 'fixed') {
                                    //TODO:
                                } else {
                                    console.log('err: EditViewForm: unknown depended change options type:', updated_field['change']['option']['type'])
                                }
                            }
                            else {
                                console.log('err: EditViewForm: unknown depended change type:', updated_field['change']['type'])
                            }
                        }
                        else {
                            console.log('err: EditViewForm: unknown depend type: ', field['depend']['type'])
                        }
                   }
                   if ( this.dependant_need_to_be_cleared(updated_field, field) ) {
                       console.log('EditViewForm: clear field:', field.display.name, ', for field changing:', updated_field.display.name)
                       this.metadata[field['change']['name']] = null
                   }
                }
            }
        },
        get_options (target = null) {
            console.log('EditViewForm: get_options(): start, target=', target)

            let self = this

            for (let section of this.page_structure['fields'] || []) {
                for (let field of section['fields'] || [section]) {
                    if ((field['change']['editable'] === true || field['change']['addable'] ) && 
                        field['change']['type'] === 'single-select' && 
                        field['change']['options']['type'] === 'db'
                    ) {
                        if (target && field['change']['name'] !== target && field['source']['key'] !== target) {
                            console.log('get_options: skip because not target. Target=', target)
                            continue
                        }

                        let params = {}
                        
                        if (this.$route.query[field['change']['options']['endpoint']]) {
                            params = this.$route.query[field['change']['options']['endpoint']]
                        }

                        for (let param of field['change']['options']['params']) {
                            if (param['type'] === 'fixed') {
                                if (Array.isArray(param['value'])) {
                                    params[param['name']] = {
                                        value: param['value'],
                                        action: 'in'
                                    }
                                }
                                else {
                                    params[param['name']] = param['value']
                                }
                            }
                            else if (param['type'] === 'variable') {
                                if (this.metadata[param['key']]) {
                                    params[param['name']] = {
                                        value: this.metadata[param['key']],
                                        action: '='
                                    }
                                }
                                else {
                                    params[param['name']] = null
                                }
                            }
                        }

                        let valid = true
                        for (let param of field['change']['options']['params']) {
                            if (!params[param['name']]) {
                                console.log('insufficient info to get option')
                                valid = false
                            }
                        }
                        if (!valid) {
                            continue
                        }

                        let packaged_params = null
                        if (field['change']['options']['method'] == 'get') {
                            packaged_params = {params: params}
                        }
                        else if (field['change']['options']['method'] == 'post') {
                            packaged_params = params
                        }

                        axios[field['change']['options']['method']](process.env.VUE_APP_API_BACKSTAGE_URL+field['change']['options']['endpoint'], packaged_params)
                            .then((response) => {
                                console.log('EditViewForm: get options:'+ field['display']['name'] + field['change']['options']['endpoint'] + ', reponse: ', response.data.payload)
                                if (response.data.success) {
                
                                    let list = response.data.payload['search_result'].map(x => {
                                        return {
                                            label: x[field['change']['options']['label']],
                                            value: x[field['change']['options']['value']]
                                        }
                                    })

                                    let cur_choice = self.metadata[field['change']['name']]
                                    this.$set(self.options, [field['change']['name']], list)
                                    this.$set(self.options_data, [field['change']['name']], response.data.payload['search_result'])
                                    this.$set(self.metadata, [field['change']['name']], cur_choice)
                                    console.log('EditViewForm this.options=', self.options)
                                    console.log('EditViewForm this.options_data=', self.options_data)
                                }
                                else {
                                    this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得選項', response.data.message)
                                }
                            })
                            .catch(err => {
                                console.log(err)
                                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得選項', this.ERROR.MSG.general_err_msg)
                            })
                    }
                    else if ((field['change']['editable'] === true || field['change']['addable'] ) && 
                        field['change']['type'] === 'single-select' && 
                        field['change']['options']['type'] === 'vuex') {
                            
                        let list = this[field['change']['options']['name']].map(x => {
                            return {
                                label: x[field['change']['options']['label']],
                                value: x[field['change']['options']['value']]
                            }
                        })

                        let cur_choice = self.metadata[field['change']['name']]
                        this.$set(self.options, [field['change']['name']], list)
                        this.$set(self.options_data, [field['change']['name']], this[field['change']['options']['name']])
                        this.$set(self.metadata, [field['change']['name']], cur_choice)
                        console.log('EditViewForm this.options=', self.options)
                        console.log('EditViewForm this.options_data=', self.options_data)
                    }
                }
            }
            console.log('EditViewForm: get_options(): done')
        },
        update_form (preloaded_data) {
            console.log('EditViewForm: update_form: preloaded_data:', preloaded_data)
   
            this.metadata = JSON.parse(JSON.stringify(preloaded_data))
            console.log('EditViewForm: metadata:', this.metadata)

            this.get_options()
        },
        inner_handle_file_remove (key, file) {
            if (this.handle_file_remove) {
                return this.handle_file_remove(key ,file)
            }
        },
        inner_handle_file_upload (key, file) {
            if (this.handle_file_upload) {
                return this.handle_file_upload(key ,file)
            }
        },
        notify_valid(valid) {
            this.$emit('update-valid', valid)
        }
    }
  };
</script>

<style lang="scss" scoped>
    /deep/.el-form-item__label {
    background-color: rgba(25, 111, 61, 0.1);
    padding: 0 5px;
    }
    /deep/.el-form-item__content {
    padding: 0 5px;
    }
    /deep/.el-tag + .el-tag {
    margin-left: 10px;
    }

    .action_buttons {
    float: right;
    .el-button {
        margin-right: 22px;
    }
    }

    .choices-radio{
    margin-bottom: 22px;
    }

    .clearfix::after {
        content: "";
        clear: both;
        display: table;
    }

    .field {
    padding: 5px;
    background-color: rgba(25, 111, 61, 0.1);
    width: 200px;
    vertical-align: top;
    &+.value {
        vertical-align: top;
        padding: 5px;
    }
    }

    // disabled 文字看不清楚改善 777d87
    /deep/.el-input.is-disabled .el-input__inner{
        color:#777d87;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner{
        color:#777d87;
    }

    .digital-object-img {
        max-width: 100%;
    }

    .detail-section {
        margin-bottom: 20px;
    }

    h1 {
        font-size: 2rem;
        line-height: 2.5rem;
    }
    h2 {
        font-size: 1.75rem;
        line-height: 2.25rem;
    }
    h3 {
        font-size: 1.5rem;
        line-height: 2rem;
    }
    h4 {
        font-size: 1.25rem;
        line-height: 1.75rem;
    }
    h5 {
        font-size: 1.125rem;
        line-height: 1.75rem;
    }

    .normal-table {
        th {
            background: #f2f2f2;
            padding: 10px;
            width: 160px;
            box-sizing: border-box;
            text-align: right;
            line-height: 1.5rem;
            color: #222;
        }
        tr {
            border-bottom: 3px solid white;
        }
        td {
            padding: 10px;
            color: #444;
            line-height: 1.5rem;
        }
    }

    .aux-info-text {
        color: #aaa;
    }

    .input-string-description {
        color: #606266;
    }

</style>
